var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CorePRG,
    {
      staticClass:
        "analyses-popular-card d-flex flex-column gr-2 pa-4 bg-gray-0 text--text text-decoration-none overflow-hidden",
      class: _vm.isMobile ? "rounded-lg" : "rounded-xl",
      attrs: {
        url: _vm.href,
        target: "_self",
        "data-qa": "analyses_popular_card",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "analyses-popular-card__name text--text text-left",
          class: _vm.isMobile ? "text-subtitle-2" : "text-subtitle-1",
        },
        [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-center gc-2" }, [
        _c(
          "div",
          {
            staticClass: "text--text text-left",
            class: _vm.isMobile ? "text-subtitle-1" : "text-h6",
          },
          [_vm._v("\n      " + _vm._s(_setup.formattedPrice) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "text-body-2 text--text text-decoration-line-through",
          },
          [_vm._v("\n      " + _vm._s(_setup.formattedOldPrice) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-2 py-1" }, [
        _c("div", { staticClass: "d-flex align-center text-left gc-2" }, [
          _c("span", {
            staticClass:
              "ui-icon-clock ui-icon-fz-medium icon-secondary--text flex-shrink-0",
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-body-2 text-secondary--text" }, [
            _vm._v("\n        " + _vm._s(_vm.duration) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-center text-left gc-2" }, [
          _c("span", {
            staticClass:
              "ui-icon-test-tube ui-icon-fz-medium icon-secondary--text flex-shrink-0",
          }),
          _vm._v(" "),
          _c("span", { staticClass: "text-body-2 text-secondary--text" }, [
            _vm._v("\n        " + _vm._s(_vm.biomaterial) + "\n      "),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }